module.exports = __webpack_public_path__ + "static/media/card-bg1.1934f032.png";